"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../hooks");
const useStyles = () => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccLoginPurchaseStyle = (0, _react.useMemo)(() => {
    const mobileProps = () => {
      if (isMobileView) {
        return {
          paddingTop: pxToRem(70),
          height: '50%'
        };
      }
      return {
        marginTop: pxToRem(40),
        marginInlineEnd: pxToRem(15)
      };
    };
    const ccLoginPurchase = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      ...mobileProps()
    });
    const ccLoginPurchaseImg = (0, _css.css)({
      width: pxToRem(145),
      height: pxToRem(128),
      backgroundColor: themeColors?.general.light,
      margin: pxToRem(20)
    });
    return {
      ccLoginPurchase,
      ccLoginPurchaseImg
    };
  }, [isMobileView, pxToRem, themeColors?.general.light]);
  return {
    'cc-Login__purchase-section': ccLoginPurchaseStyle.ccLoginPurchase,
    'cc-Login__purchase-img': ccLoginPurchaseStyle.ccLoginPurchaseImg
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;